import AuthForm from '#Auth/components/Form/AuthForm.vue'
import { AuthFormAction } from '#Auth/components/Form/type'

export const useAuthInteractive = () => {
  const action = ref<AuthFormAction>(AuthFormAction.signIn)

  const { startAdd } = useFormModal({
    formComponent: AuthForm,
    overlayType: 'slideover',
    formAttrs: {
      action,
      class: computed(() => 'flex-1'),
      onGoTo: () => handleChangeAction,
    },
    onSubmit() {
      return true
    },
    modalProps: {
      ui: {
        content: 'max-w-140 sm:p-10 p-4',
        header: 'border-none p-0',
      },
    },
  })

  function handleChangeAction(newAction: AuthFormAction) {
    action.value = newAction
  }

  function openAuth(newAction: AuthFormAction = AuthFormAction.signIn) {
    action.value = newAction
    startAdd()
  }

  return {
    openAuth,
  }
}
